import { useState } from "react";
import { useData } from "@/hooks/useData";
import { EnergySource } from "@/types/energy-source/energy-source.types";
import { useEnergySourceFilters } from "@/hooks/energy-sources/useEnergySourceFilters";

export interface EnergySourceWithId extends EnergySource {
    id: string;
}

export const useEnergySourceTable = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [nameFilters, setNameFilters] = useState<string[]>([]);

    const {
        data: energySources,
        loading,
        refetch,
    } = useData<EnergySourceWithId>({
        collectionName: "setup_energyConsumption",
    });

    const { filteredEnergySources, getUniqueOptions } = useEnergySourceFilters({
        energySources,
        searchTerm,
        nameFilters,
    });

    const clearFilters = () => {
        setSearchTerm("");
        setNameFilters([]);
    };

    const nameOptions = getUniqueOptions("name");

    return {
        energySources,
        filteredEnergySources,
        loading,
        refetch,
        searchTerm,
        setSearchTerm,
        nameFilters,
        setNameFilters,
        clearFilters,
        nameOptions,
    };
}; 